import * as React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import UserPointsBadge from './UserPointsBadge';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useAppState } from '../../reduxish/appState';
import CasinoSearchAndSort from '../casino/CasinoSearchAndSort';


export default function NavbarMobileTop({ showSearch = false }: { showSearch: boolean }) {
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const { state } = useAppState();
    const { signOut, authUser, isAuthenticated } = state.auth!;
    const location = useLocation();
    const navigate = useNavigate();
    const isHome = location.pathname === '/';
    const monthlyPoints = state.userPoints?.monthly ?? 0;

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <AppBar position="sticky" sx={{ top: 0 }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography sx={{ flexGrow: 1, mr: 1 }} >
                        {isHome
                            ? <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}><HomeIcon /></Link>
                            : <IconButton onClick={() => navigate(-1)} sx={{ p: 0, color: 'inherit' }} aria-label="Go back"><ArrowBackIcon /></IconButton>
                        }
                    </Typography>

                    {showSearch && <CasinoSearchAndSort />}

                    <Box sx={{ flexGrow: 0 }}>
                        {
                            (isAuthenticated && authUser)
                                ?
                                <>
                                    <Tooltip title="Open settings">
                                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                            <UserPointsBadge points={monthlyPoints}>
                                                <Avatar alt={authUser.displayName} src={authUser.photoURL} sx={{ bgcolor: 'primary.dark', color: 'secondary.contrastText' }} />
                                            </UserPointsBadge>
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{ mt: '45px' }}
                                        id="menu-appbar"
                                        anchorEl={anchorElUser}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(anchorElUser)}
                                        onClose={handleCloseUserMenu}
                                    >
                                        {/* <MenuItem key='user-profile' component={RouterLink} to="/profile">
                                            <Typography textAlign="center">Profile</Typography>
                                        </MenuItem> */}
                                        <Link to="/profile" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <MenuItem key='user-profile'>
                                                <Typography sx={{ textAlign: 'center' }}>Profile</Typography>
                                            </MenuItem>
                                        </Link>
                                        <MenuItem key='user-logout' onClick={signOut} >
                                            <Typography sx={{ textAlign: 'center' }}>Sign Out</Typography>
                                        </MenuItem>
                                    </Menu>
                                </>
                                :
                                <Box sx={{ flexGrow: 1, display: 'flex' }}>
                                    {/* <Button
                                        key='about-link'
                                        component={RouterLink} to="/signin"
                                        sx={{ color: 'white', display: 'block', minWidth: '72px' }}
                                    >
                                        Sign In
                                    </Button> */}
                                    <Link to="/signin" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        <Button
                                            key='about-link'
                                            sx={{ color: 'primary.contrastText', display: 'block', minWidth: '72px' }}
                                        >
                                            Sign In
                                        </Button>
                                    </Link>

                                </Box>
                        }
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}